import { termsOfServiceHtml } from '@/assets/html/TermsOfService';

function createMarkup(htmlString: string) {
  return { __html: htmlString };
}

const TermsOfService = () => {
  return <div className="overflow-y-scroll" dangerouslySetInnerHTML={createMarkup(termsOfServiceHtml)} />;
};

export default TermsOfService;
